import React from 'react'
import { Link } from 'react-router-dom'
import Swal from 'sweetalert2'
import Constant, { getCurrency, roundToMax3Decimals } from '../../Constant.js'
import axios from 'axios'
import moment from 'moment'
import MUIDataTable from 'mui-datatables'
import Loader from '../../common/Loader.js'
import { write, utils } from 'xlsx'
import Button from '../../common/CustomComponents/Button.js'

class AnnualReport extends React.Component {
  state = {
    year: moment().format('YYYY'),
    country: 'KWT',
    type: 'cruise',
    item: 'sales',
    typeTag: '',

    country_list: [],
    typeTagList: Constant.getTypeTags(),
    yearList: Array.from({ length: new Date().getFullYear() - 2020 + 1 }, (_, i) => 2020 + i),

    isSearching: false,

    data: [],
    reportUrl: '',
  }

  componentDidMount() {
    this.getCountries()
  }

  getCountries = async () => {
    await axios
      .get(Constant.getAPI() + '/multi-country/list-countries?show_all_countries=true', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name:
            localStorage.getItem('loged_In_role') === 'super-admin'
              ? ''
              : `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          this.setState({
            country_list: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = (event) => {
    this.setState({
      data: [],
      [event?.target?.name]: event?.target?.value,
    })
  }

  clearSearch = async () => {
    this.setState({
      year: moment().format('YYYY'),
      country: 'KWT',
      type: 'cruise',
      item: 'sales',
      typeTag: '',

      data: [],
    })
  }

  getReports = async () => {
    this.setState({ isSearching: true })

    let data = {
      country: this.state.country,
      typeTag: this.state.typeTag,
      year: this.state.year,
      type: this.state.type,
      item: this.state.item,
    }

    await axios
      .get(Constant.getAPI() + `/admin/annual-report`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: data,
      })
      .then((response) => {
        this.setState({
          data: response?.data?.data?.list,
        })
      })
      .catch((err) => {
        Swal.fire({
          title: err?.response?.data?.message || err?.response?.data?.data,
          icon: 'error',
          text: err?.response?.data?.data?.details[0]?.message,
          type: 'error',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ok',
        })
      })
      .finally(() => {
        this.setState({
          isSearching: false,
        })
      })
  }

  searchData = async () => {
    this.setState(
      {
        data: [],
      },
      () => {
        this.getReports()
      }
    )
  }

  render() {
    const columns = [
      {
        name: 'index',
        label: 'No.',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'name',
        label: 'Name',
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: 'january',
        label: 'January',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (
            <div style={{ textWrap: 'nowrap' }}>
              {value
                ? this.state.item === 'bookings'
                  ? roundToMax3Decimals(value)
                  : `${roundToMax3Decimals(value)} ${getCurrency(this.state.country)}`
                : '--'}
            </div>
          ),
        },
      },
      {
        name: 'february',
        label: 'February',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (
            <div style={{ textWrap: 'nowrap' }}>
              {value
                ? this.state.item === 'bookings'
                  ? roundToMax3Decimals(value)
                  : `${roundToMax3Decimals(value)} ${getCurrency(this.state.country)}`
                : '--'}
            </div>
          ),
        },
      },
      {
        name: 'march',
        label: 'March',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (
            <div style={{ textWrap: 'nowrap' }}>
              {value
                ? this.state.item === 'bookings'
                  ? roundToMax3Decimals(value)
                  : `${roundToMax3Decimals(value)} ${getCurrency(this.state.country)}`
                : '--'}
            </div>
          ),
        },
      },
      {
        name: 'april',
        label: 'April',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (
            <div style={{ textWrap: 'nowrap' }}>
              {value
                ? this.state.item === 'bookings'
                  ? roundToMax3Decimals(value)
                  : `${roundToMax3Decimals(value)} ${getCurrency(this.state.country)}`
                : '--'}
            </div>
          ),
        },
      },
      {
        name: 'may',
        label: 'May',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (
            <div style={{ textWrap: 'nowrap' }}>
              {value
                ? this.state.item === 'bookings'
                  ? roundToMax3Decimals(value)
                  : `${roundToMax3Decimals(value)} ${getCurrency(this.state.country)}`
                : '--'}
            </div>
          ),
        },
      },
      {
        name: 'june',
        label: 'June',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (
            <div style={{ textWrap: 'nowrap' }}>
              {value
                ? this.state.item === 'bookings'
                  ? roundToMax3Decimals(value)
                  : `${roundToMax3Decimals(value)} ${getCurrency(this.state.country)}`
                : '--'}
            </div>
          ),
        },
      },
      {
        name: 'july',
        label: 'July',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (
            <div style={{ textWrap: 'nowrap' }}>
              {value
                ? this.state.item === 'bookings'
                  ? roundToMax3Decimals(value)
                  : `${roundToMax3Decimals(value)} ${getCurrency(this.state.country)}`
                : '--'}
            </div>
          ),
        },
      },
      {
        name: 'august',
        label: 'August',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (
            <div style={{ textWrap: 'nowrap' }}>
              {value
                ? this.state.item === 'bookings'
                  ? roundToMax3Decimals(value)
                  : `${roundToMax3Decimals(value)} ${getCurrency(this.state.country)}`
                : '--'}
            </div>
          ),
        },
      },
      {
        name: 'september',
        label: 'September',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (
            <div style={{ textWrap: 'nowrap' }}>
              {value
                ? this.state.item === 'bookings'
                  ? roundToMax3Decimals(value)
                  : `${roundToMax3Decimals(value)} ${getCurrency(this.state.country)}`
                : '--'}
            </div>
          ),
        },
      },
      {
        name: 'october',
        label: 'October',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (
            <div style={{ textWrap: 'nowrap' }}>
              {value
                ? this.state.item === 'bookings'
                  ? roundToMax3Decimals(value)
                  : `${roundToMax3Decimals(value)} ${getCurrency(this.state.country)}`
                : '--'}
            </div>
          ),
        },
      },
      {
        name: 'november',
        label: 'November',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (
            <div style={{ textWrap: 'nowrap' }}>
              {value
                ? this.state.item === 'bookings'
                  ? roundToMax3Decimals(value)
                  : `${roundToMax3Decimals(value)} ${getCurrency(this.state.country)}`
                : '--'}
            </div>
          ),
        },
      },
      {
        name: 'december',
        label: 'December',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (
            <div style={{ textWrap: 'nowrap' }}>
              {value
                ? this.state.item === 'bookings'
                  ? roundToMax3Decimals(value)
                  : `${roundToMax3Decimals(value)} ${getCurrency(this.state.country)}`
                : '--'}
            </div>
          ),
        },
      },
      {
        name: 'total',
        label: 'Total',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (
            <div style={{ textWrap: 'nowrap' }}>
              {value
                ? this.state.item === 'bookings'
                  ? roundToMax3Decimals(value)
                  : `${roundToMax3Decimals(value)} ${getCurrency(this.state.country)}`
                : '--'}
            </div>
          ),
        },
      },
    ]

    const options = {
      filter: false,
      filterType: 'dropdown',
      viewColumns: false,
      print: false,
      download: true,
      downloadOptions: {
        filename: 'Bookings',
      },
      rowsPerPage: 250,
      rowsPerPageOptions: [10, 50, 100, 250, 500],
      onDownload: (buildHead, buildBody, columns, values) => {
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        const fileExtension = '.xlsx'
        const fileName = `Bookings`

        const json = values.reduce((result, val) => {
          const temp = {}
          val.data.forEach((v, idx) => {
            temp[columns[idx].label] = v
          })
          result.push(temp)
          return result
        }, [])

        const ws = utils.json_to_sheet(json)
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] }
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' })
        const blob = new Blob([excelBuffer], { type: fileType })
        const file = new File([blob], fileName + fileExtension, { type: fileType })

        const downloadLink = document.createElement('a')
        downloadLink.href = URL.createObjectURL(file)
        downloadLink.download = file.name

        downloadLink.click()

        // cancel default  CSV download from table
        return false
      },
      selectableRows: 'none',
      textLabels: {
        body: {
          noMatch: this.state.isSearching ? <Loader open={this.state.isSearching} /> : 'Sorry, No data Found',
          toolTip: 'Sort',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Annual Report</h4>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Annual Report</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Filter: typeTag on bookings */}
            <div className="page-body">
              <div className="row">
                <div className="col-sm-12">
                  <div className="card card-border-default">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Country</label>
                            <div className="col-sm-8">
                              <select
                                name="country"
                                className="form-control"
                                value={this.state.country}
                                onChange={this.handleChange}
                              >
                                {this.state.country_list.map((country) => (
                                  <option
                                    value={country.country_short_name}
                                    key={country.country_short_name}
                                  >
                                    {country.country_name_en + '/' + country.country_name_ar}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Year</label>
                            <div className="col-sm-8">
                              <select
                                name="year"
                                className="form-control"
                                value={this.state.year}
                                onChange={this.handleChange}
                              >
                                {this.state.yearList.map((year, index) => (
                                  <option
                                    value={year}
                                    key={index}
                                  >
                                    {year}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Type</label>
                            <div className="col-sm-8">
                              <select
                                name="type"
                                className="form-control"
                                value={this.state.type}
                                onChange={this.handleChange}
                              >
                                <option value={'cruise'}>Cruise</option>
                                <option value={'chalet'}>Chalet</option>
                                <option value={'event'}>Event</option>
                                <option value={'kashta'}>Kashta</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Item</label>
                            <div className="col-sm-8">
                              <select
                                name="item"
                                className="form-control"
                                value={this.state.item}
                                onChange={this.handleChange}
                              >
                                <option value={'sales'}>Sales</option>
                                <option value={'bookings'}>Bookings</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group row">
                            <label className="col-sm-4 col-form-label">Tag Type</label>
                            <div className="col-sm-8">
                              <select
                                name="typeTag"
                                className="form-control"
                                onChange={this.handleChange}
                                value={this.state.typeTag}
                              >
                                <option value={''}>All</option>
                                {this.state?.typeTagList?.length > 0
                                  ? this.state.typeTagList.map((tag) => (
                                    <option
                                      value={tag}
                                      key={tag}
                                    >
                                      {tag}
                                    </option>
                                  ))
                                  : null}
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="col-md-9">
                          <div className="row">
                            <div className="text-right col-12">
                              <Button
                                variant="outlined"
                                onClick={this.clearSearch}
                                disabled={this.state.isSearching}
                              >
                                Clear
                              </Button>
                              <Button
                                onClick={this.searchData}
                                disabled={this.state.isSearching}
                              >
                                {this.state.isSearching ? 'Searching...!' : 'Search'}
                              </Button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="card">
                    <div className="dt-responsive table-responsive">
                      <MUIDataTable
                        title={<span className="text-capitalize h5">{this.state.type} Report</span>}
                        className="table-responsive"
                        data={this.state.data}
                        columns={columns}
                        options={options}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AnnualReport
